module.exports = __webpack_public_path__ + "img/logo.3c2469c5.jpg";